export default "__VITE_ASSET__IiZrCkSC__"